import { createApp } from 'vue'
import { createPinia } from 'pinia'
import posthog from 'posthog-js'
import App from './App.vue'
import router from './router'
import './style.css'

// Initialize domain state store for navigation persistence
import { useDomainStateStore } from './stores/navigation/domainStateStore'

// Initialize PostHog for analytics, heatmaps, and feature flags
const posthogApiKey = import.meta.env.VITE_POSTHOG_API_KEY
const posthogHost = import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com'
const enablePostHog = import.meta.env.VITE_ENABLE_POSTHOG !== 'false'

if (enablePostHog && posthogApiKey && posthogApiKey !== 'phc_YOUR_PROJECT_API_KEY') {
  posthog.init(posthogApiKey, {
    api_host: posthogHost,
    enable_heatmaps: true,
    enable_feature_flags: true,
    enable_recording_console_log: true,
    capture_pageview: true,
    capture_pageleave: true,
    respect_dnt: true,
    persistence: 'localStorage+cookie',
    loaded: () => {
      if (import.meta.env.DEV) {
        console.log('PostHog loaded in development mode')
      }
    }
  })
} else if (import.meta.env.DEV) {
  console.log('PostHog disabled - configure VITE_POSTHOG_API_KEY in .env to enable')
}

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Initialize navigation state persistence after Pinia is installed
const domainStateStore = useDomainStateStore()
domainStateStore.init()

app.config.globalProperties.$posthog = posthog

app.mount('#app')